import { CommonModule } from '@angular/common';
import { NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';
import { BaseDirective } from '../../../../base.directive';

@Component({
    selector: 'eui-overlay-header',
    templateUrl: './eui-overlay-header.component.html',
    styleUrls: ['../../styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiOverlayHeaderComponent extends BaseDirective {

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses(`eui-overlay-header`),
        ].join(' ').trim();
    }

    constructor (
    ) {
        super();
    }
}
